import { Button } from "@/components/ui/button";
import { STORE_FILTER_TEXT } from "./constants";

interface StoreFilterFooterProps {
  selectedCount: number;
  onCancel: () => void;
  onApply: () => void;
}

/** Rodapé do painel: Cancelar + Aplicar (N), desabilitado sem seleção. */
export function StoreFilterFooter({
  selectedCount,
  onCancel,
  onApply,
}: StoreFilterFooterProps) {
  return (
    <div className="flex items-center justify-end gap-2 border-t px-3 py-2.5">
      <Button variant="outline" size="sm" className="h-8" onClick={onCancel}>
        {STORE_FILTER_TEXT.cancel}
      </Button>
      <Button
        size="sm"
        className="h-8"
        disabled={selectedCount === 0}
        onClick={onApply}
      >
        {STORE_FILTER_TEXT.apply} ({selectedCount})
      </Button>
    </div>
  );
}
